import React from 'react';
import { string, func } from 'prop-types';
import classNames from 'classnames';
import moment from 'moment/moment';
import { MILITARY_DATE_TIME } from '../../constants/constants';

import './availability-button.scss';

export const AvailabilityButton = ({
  startDate,
  endDate,
  identifier,
  setSelectedButton,
  selectedButton
}) => {

  const cursorClass = classNames(
    'availability-button',
    selectedButton === identifier ? 'selected' : 'un-selected',
    { pointer: true }
  );

  return (
    <button
      className={cursorClass}
      data-testid={`${identifier}-button`}
      onClick={() => setSelectedButton(identifier)}
      type="button"
    >
      <>
        {moment(startDate, MILITARY_DATE_TIME).format('ddd M/D h:mm a')}&nbsp;-&nbsp;
        {moment(endDate, MILITARY_DATE_TIME).format('ddd M/D h:mm a')}
      </>
    </button>
  );
};

AvailabilityButton.propTypes = {
  identifier: string.isRequired,
  startDate: string.isRequired,
  endDate: string.isRequired,
  setSelectedButton: func.isRequired,
  selectedButton: string.isRequired
};
